
import React from 'react'
import './topicsdisplay.css'
import StatusContext from '../../../contexts/StatusContext'
import ComprehensiveResponsesContext from '../../../contexts/ComprehensiveResponsesContext'
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
import { ArrowForwardIconWhite } from '../customicons/ArrowForwardIconWhite';
import { ArrowUpward, ArrowDownward} from "@mui/icons-material"
import RefreshIcon from '@mui/icons-material/Refresh';
import { CopyTextIconComprehensiveResponses } from '../customicons/CopyTextIconComprehensiveResponses';
import { CustomTooltip } from '../customtooltip/CustomTooltip';

export const TopicsDisplay = ({ index, topic, displayprompt }) => {
  let {
    changeLanguage,
    isLoading,
    responseMode,
} = React.useContext(StatusContext); 

let {
  onRequestSubtopic,
  onDisplaySubtopic,

} = React.useContext(ComprehensiveResponsesContext); 


const handleRequestSubtopic = () => {
  console.log("handleRequestSubtopic: ", displayprompt.subtopic)
  onRequestSubtopic(index, topic, displayprompt)
}

const handleDisplaySubtopic = (display) => {
  console.log("handleDisplaySubtopic:", display)
  onDisplaySubtopic(index, displayprompt, display)
}


  
  return (
    <div disabled={isLoading} >
     
      {
        <div key={displayprompt.id}>
          {
         
            <div className="promptTextPrompt" >
            
            {
           
              displayprompt.response.length === 0 ? 
                  <>
                  <div className="flex-container">
                    <CustomTooltip title={changeLanguage('comprehensiveresponses', 'sendrequest')}>
                      <span>
                    <ArrowForwardIconWhite  onClick={handleRequestSubtopic} /> 
                    </span>
                    </CustomTooltip>
                    <span style = {{paddingLeft: '10px', fontSize: '18px'}}>{displayprompt.subtopic}</span>
                  </div>
                  {
                    (responseMode > 1) && 
                    Array.isArray(displayprompt.subsubtopics) &&
                      displayprompt.subsubtopics.map((item, index1) => (
    
                        <React.Fragment key={item.title}> 
                        <p></p>
                        <p style = {{paddingLeft:'50px', marginTop:'-10px'}}>{item.title}</p>
                        
                       </React.Fragment>
                      ))
                   }
                  </>
                  :
                  <>
                    {
                      
                      (displayprompt.showresponse) && 
                      <>
                      <div className= 'flex-container'>
                      <CustomTooltip title={changeLanguage('comprehensiveresponses', 'hideresponse')}>
                        <span>
                        <ArrowUpward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={()=> {handleDisplaySubtopic(!displayprompt.showresponse)}} />
                      </span>
                      </CustomTooltip>
                      <CustomTooltip title={changeLanguage('comprehensiveresponses', 'sendrequestagain')}>
                        <span>
                          <RefreshIcon className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={() => { !isLoading && handleRequestSubtopic() }} />
                        </span>
                      </CustomTooltip>

                      <CopyTextIconComprehensiveResponses prompt={displayprompt} />
                      </div>
                      </>
                  }

                    {
                      (!displayprompt.showresponse) && 
                      <>
                      <div className= 'flex-container'>
                      <CustomTooltip title={changeLanguage('comprehensiveresponses', 'showresponse')}>
                        <span>
                          <ArrowDownward className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={()=> {handleDisplaySubtopic(!displayprompt.showresponse)}} />
                        </span>
                      </CustomTooltip>
                      <CustomTooltip title={changeLanguage('comprehensiveresponses', 'sendrequestagain')}>
                        <span>
                          <RefreshIcon className="promptIconColoredOrange" style={{marginBottom: '5px', marginRight:'10px'}} onClick={() => { !isLoading && handleRequestSubtopic() }} />
                        </span>
                      </CustomTooltip>
                      <CopyTextIconComprehensiveResponses prompt={displayprompt} />
                      </div>
                      </>
                    }
                      {
                        displayprompt.showresponse ? 
                        <MarkdownResponseDisplay text={displayprompt.response} />
                        :
                        <>
                        <span style = {{paddingLeft: '10px', fontSize: '18px'}}>{displayprompt.subtopic}</span>
                        {
                          (responseMode > 1) &&
                            Array.isArray(displayprompt.subsubtopics) &&
                              displayprompt.subsubtopics.map((item, index1) => (
        
                              <React.Fragment key={item.title}> 
                              <p></p>
                              <p style = {{paddingLeft:'50px', marginTop:'-10px'}}>{item.title}</p>
                            
                            </React.Fragment>
                          ))
                        }
                        </>
                      }
                  </>

               

            }
            
          
            
              
               
             
            </div>
            
          }
        </div>
        
      }
    </div>
  )
}


TopicsDisplay.defaultProps = {
  showprompts: true,
  showRefresh: true
};

export default TopicsDisplay
